// extracted by mini-css-extract-plugin
module.exports = {"paymentInfo":"providers-gyg-components-GygTourInfoEx-GygTourInfoForm-GygTourShoppingForm-GygTourShoppingForm__paymentInfo--1KqEx"};